// firebase.ts or firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  browserSessionPersistence,
  GoogleAuthProvider,
  FacebookAuthProvider,
   OAuthProvider,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Use environment variables for Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Auth Providers
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const oAuthProvider = new OAuthProvider('apple.com');

facebookProvider.setCustomParameters({ display: "popup" });

export default app;
